import UnitQuizResult from './model';
import create from './create';

UnitQuizResult.create = create;

export default UnitQuizResult;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/UnitQuizResult/index.js